import React from 'react';
import { Container, Navbar, Nav, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

const Navigation = () => {
    return (
    <Navbar bg="dark" variant="dark" expand="lg" sticky="top" className="shadow-sm">
            <Container>
                <LinkContainer to="/">
                    <Navbar.Brand style={{ margin: 0, padding: 0 }}>
                        <img
                            src={`${process.env.PUBLIC_URL}/Nicer-Lawns-LogoPNGTransparency.png`}
                            height="80"
                            className="d-inline-block align-top"
                            alt="Nicer Lawns"
                        />
                    </Navbar.Brand>
                </LinkContainer>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto align-items-center">
                        <Nav.Item className="me-3 d-none d-md-block">
                            <a href="tel:(816)352-1651" className="nav-link">(816) 352-1651</a>
                        </Nav.Item>
                        <Nav.Item className="me-3 d-none d-md-block">
                            <Button href="/contact-us" variant="outline-success" size="sm">Get a Quote</Button>
                        </Nav.Item>
                        <LinkContainer to="/">
                            <Nav.Link>Home</Nav.Link>
                        </LinkContainer>
                        <LinkContainer to="/contact-us">
                            <Nav.Link>Contact Us</Nav.Link>
                        </LinkContainer>
                        <LinkContainer to="/about">
                            <Nav.Link>About</Nav.Link>
                        </LinkContainer>
                        <LinkContainer to="/services">
                            <Nav.Link>Services</Nav.Link>
                        </LinkContainer>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Navigation;
